import { css } from 'linaria';

export const adplatformTrainingWebinarItemWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:not(:last-of-type) {
    margin-bottom: 48px;

    @media (--to-desktop) {
      margin-bottom: 32px;
    }
  }

  @media (--to-desktop) {
    flex-direction: column-reverse;
    align-items: flex-start;
    row-gap: 24px;
  }

  @media (--only-mobile) {
    row-gap: 40px;
  }
`;

export const adplatformTrainingWebinarItemMediaWrapper = css`
  width: 776px;
  border-radius: var(--rounding-m);

  @media (--only-desktop) {
    width: 534px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const adplatformTrainingWebinarItemMedia = css`
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--rounding-m);
`;

export const adplatformTrainingWebinarItemImgBtn = css`
  && {
    position: relative;
    border: none;

    &&::before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 48px;
      height: 48px;
      background-color: var(--control-primary);
      background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/adplatform-training/webinar/play-icon.png/play-icon.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      border-radius: 100%;
      transform: translate(-50%, -50%);
      content: '';
    }

    &:hover {
      &&::before {
        background-color: var(--control-hover-primary);
      }
    }
  }
`;

export const adplatformTrainingWebinarItemPointsList = css`
  width: 370px;
  padding: 0;
  margin: 0;
  list-style: none;

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const adplatformTrainingWebinarItemPoint = css`
  display: flex;
  align-items: center;
  height: 60px;
  padding-left: 6px;
  margin-bottom: 16px;
  column-gap: 10px;

  @media (--only-tablet) {
    height: 44px;
    padding-left: 2px;
    margin-bottom: 0;
    column-gap: 6px;
  }

  @media (--only-mobile) {
    align-items: flex-start;
    height: auto;
    padding-left: 0;
    margin-bottom: 12px;
    column-gap: 4px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const adplatformTrainingWebinarItemPointIcon = css`
  && {
    @media (--only-tablet) {
      width: 36px;
      height: 36px;
    }

    @media (--only-mobile) {
      width: 24px;
      height: 24px;
    }
  }
`;
